import React from 'react';
import PropTypes from 'prop-types';

function DownArrow({ active, activeColor, color }) {
  return (
    <path
      d="M164.993 252.952C163.887 252.929 163.032 253.263 162.235 253.765C161.438 254.266 160.407 255.108 157.725 257.803C155.043 260.497 150.709 265.045 148.407 267.533C146.104 270.02 145.834 270.445 145.446 272.961C145.059 275.477 144.554 280.081 144.19 284.083C143.828 288.084 143.607 291.479 143.552 293.791C143.497 296.103 143.607 297.328 143.989 298.535C144.371 299.74 145.024 300.926 145.908 301.921C146.792 302.916 147.908 303.719 148.837 304.246C149.766 304.773 150.51 305.025 152.053 305.296C153.595 305.567 155.936 305.859 158.327 306.01C160.599 306.153 164.841 306.188 164.993 306.185C165.146 306.187 169.386 306.151 171.659 306.01C174.05 305.859 176.391 305.567 177.933 305.296C179.476 305.025 180.219 304.773 181.149 304.246C182.077 303.719 183.193 302.916 184.078 301.921C184.962 300.926 185.615 299.74 185.997 298.535C186.379 297.328 186.49 296.103 186.435 293.791C186.379 291.479 186.158 288.084 185.795 284.083C185.432 280.081 184.926 275.477 184.54 272.961C184.152 270.445 183.881 270.02 181.579 267.533C179.276 265.045 174.943 260.497 172.26 257.803C169.578 255.108 168.547 254.266 167.75 253.765C166.978 253.266 166.1 252.976 164.993 252.952Z"
      fill={active ? activeColor : color}
    />
  );
}

DownArrow.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

DownArrow.defaultProps = {
  active: false,
  activeColor: '#000000',
  color: '#D7DEE6',
};

export default DownArrow;
